/**
 * buy-box.js — Custom buy box for Bone Broth Collagen Protein (formthr store)
 *
 * Purchase flow:
 *  - One-off:   adds 1x main variant → opens cart drawer
 *  - Monthly:   adds 1x main variant (+ selling plan) + gift items → /checkout?discount=FreeGift
 *  - Quarterly: adds 3x main variant (+ selling plan) + gift items → /checkout?discount=FreeGift
 *
 * TODOs:
 *  - Fill in selling plan IDs in snippets/1-buy-box.liquid once Skio / Recharge is live.
 *  - Verify gift product handles ('forever-frother', 'farmers-market-tote') in Shopify admin.
 */
(function () {
  'use strict';

  function init() {
    var box = document.querySelector('.formthr-buy-box');
    if (!box || box.dataset.initialized) return;
    var giftDialog = box.querySelector('.mthr-gift-dialog');
    if (giftDialog) {
      box.querySelectorAll('.mthr-gift-preview').forEach(function (button) {
        button.addEventListener('click', function () {
          var photo = giftDialog.querySelector('img');
          photo.src = button.dataset.giftImage;
          photo.alt = button.dataset.giftName;
          giftDialog.querySelector('.mthr-gift-dialog__name').textContent = button.dataset.giftName;
          giftDialog.showModal();
        });
      });
      giftDialog.querySelector('.mthr-gift-dialog__close').addEventListener('click', function () { giftDialog.close(); });
      giftDialog.addEventListener('click', function (event) {
        var rect = giftDialog.getBoundingClientRect();
        if (event.target === giftDialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) giftDialog.close();
      });
    }

    box.dataset.initialized = 'true';

    // Read static config embedded via Liquid data attributes
    var monthlyPlanId    = parseInt(box.dataset.monthlyPlanId    || 0, 10);
    var quarterlyPlanId  = parseInt(box.dataset.quarterlyPlanId  || 0, 10);
    var frotherVariantId = parseInt(box.dataset.frotherVariantId || 0, 10);
    var toteVariantId    = parseInt(box.dataset.toteVariantId    || 0, 10);
    var priceMonthly     = parseInt(box.dataset.priceMonthly     || 0, 10);
    var priceQuarterly   = parseInt(box.dataset.priceQuarterly   || 0, 10);
    var priceOnetime     = parseInt(box.dataset.priceOnetime     || 0, 10);

    // State
    var activeFlavorBtn   = box.querySelector('.formthr-buy-box__flavor--active');
    var selectedVariantId = activeFlavorBtn ? parseInt(activeFlavorBtn.dataset.variantId, 10) : 0;
    var selectedPlan      = 'monthly';
    var secondVariantId = 0;
    var secondFlavorName = '';
    var firstFlavorName = activeFlavorBtn ? activeFlavorBtn.dataset.flavorName : '';
    function bagCount() { return secondVariantId ? 2 : 1; }

    var flavorLabelEl = box.querySelector('.formthr-buy-box__flavor-selected');

    var flavorVideo = box.querySelector('[data-flavor-video]');
    var videoVisible = false;
    function syncFlavorVideo() {
      if (!flavorVideo) return;
      var selected = flavorVideo.closest('button').classList.contains('formthr-buy-box__flavor--active');
      if (selected && videoVisible && !document.hidden && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        flavorVideo.muted = true;
        flavorVideo.play().catch(function () {});
      } else { flavorVideo.pause(); }
    }
    if (flavorVideo) {
      new IntersectionObserver(function (entries) { videoVisible = entries[0].isIntersecting; syncFlavorVideo(); }, {threshold: 0.1}).observe(flavorVideo);
      document.addEventListener('visibilitychange', syncFlavorVideo);
    }


    // ── Flavor picker ──────────────────────────────────────────────────
    function syncFlavorGallery(btn) {
      var section = box.closest('.shopify-section');
      var gallery = section && section.querySelector('mthr-buy-gallery, media-gallery');
      if (!gallery || !btn) return;
      if (secondVariantId && typeof gallery.selectCombo === 'function' && gallery.selectCombo(firstFlavorName, secondFlavorName)) return;
      if (typeof gallery.selectVariant === 'function' && gallery.selectVariant(btn.dataset.variantId)) return;
      if (btn.dataset.mediaId && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(btn.dataset.mediaId, false, true);
    }

    box.querySelectorAll('.formthr-buy-box__flavor').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.available === 'false') return;

        btn.parentElement.querySelectorAll('.formthr-buy-box__flavor').forEach(function (b) {
          b.classList.remove('formthr-buy-box__flavor--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('formthr-buy-box__flavor--active');
        btn.setAttribute('aria-pressed', 'true');
        firstFlavorName = btn.dataset.flavorName;
        syncFlavorVideo();
        selectedVariantId = parseInt(btn.dataset.variantId, 10);
        syncFlavorGallery(btn);
        if (flavorLabelEl && btn.dataset.flavorName) {
          flavorLabelEl.textContent = btn.dataset.flavorName;
        }
        syncPurchase();
      });
    });

    // ── Purchase plan picker ───────────────────────────────────────────
    var autoshipSwitch = box.querySelector('.mthr-autoship__switch');
    autoshipSwitch.addEventListener('change', function () {
      selectedPlan = autoshipSwitch.checked ? 'monthly' : 'onetime';
      syncPurchase();
    });
    var addFlavor = box.querySelector('.mthr-add-flavor');
    var secondPanel = box.querySelector('.mthr-second-flavor');
    var secondChoices = box.querySelector('[data-second-choices]');
    var firstChoices = box.querySelector('.formthr-buy-box__flavors');
    Array.from(firstChoices.children).forEach(function (original) {
      var choice = original.cloneNode(true);
      choice.classList.remove('formthr-buy-box__flavor--active');
      choice.setAttribute('aria-pressed', 'false');
      var discountBadge = document.createElement('span');
      discountBadge.className = 'formthr-second-bag-badge';
      discountBadge.textContent = '10% OFF';
      choice.querySelector('.formthr-buy-box__flavor-img-wrap').appendChild(discountBadge);
      choice.setAttribute('aria-label', choice.dataset.flavorName + ', second bag 10% off');
      var video = choice.querySelector('video');
      if (video) {
        var image = document.createElement('img');
        image.src = video.poster; image.alt = ''; video.replaceWith(image);
      }
      choice.addEventListener('click', function () {
        if (choice.dataset.available === 'false') return;
        selectSecond(choice); syncPurchase();
      });
      secondChoices.appendChild(choice);
    });
    function selectSecond(choice) {
      secondVariantId = parseInt(choice.dataset.variantId, 10);
      secondFlavorName = choice.dataset.flavorName;
      syncFlavorGallery(choice);
      Array.from(secondChoices.children).forEach(function (item) {
        item.classList.toggle('formthr-buy-box__flavor--active', item === choice);
        item.setAttribute('aria-pressed', item === choice ? 'true' : 'false');
      });
      box.querySelector('[data-second-name]').textContent = secondFlavorName;
    }
    addFlavor.addEventListener('click', function () {
      var available = Array.from(secondChoices.children).filter(function (b) { return b.dataset.available !== 'false'; });
      var choice = available.find(function (b) { return parseInt(b.dataset.variantId, 10) !== selectedVariantId; }) || available[0];
      if (!choice) return;
      selectSecond(choice); secondPanel.hidden = false; addFlavor.hidden = true;
      addFlavor.setAttribute('aria-expanded', 'true'); syncPurchase();
    });
    box.querySelector('.mthr-remove-flavor').addEventListener('click', function () {
      secondVariantId = 0; secondPanel.hidden = true; addFlavor.hidden = false;
      syncFlavorGallery(firstChoices.querySelector('.formthr-buy-box__flavor--active'));
      addFlavor.setAttribute('aria-expanded', 'false'); syncPurchase(); addFlavor.focus();
    });
    function syncPurchase() {
      var subscription = selectedPlan === 'monthly';
      var count = bagCount();
      box.querySelector('[data-plan-title]').textContent = subscription ? 'Autoship & Save' : 'One-time purchase';
      box.querySelector('[data-plan-schedule]').textContent = count + (count === 1 ? ' bag · ' : ' bags · ') + (25 * count) + ' servings' + (subscription ? ' every 4 weeks' : ' · Delivered once');
      box.querySelector('[data-plan-price]').textContent = formatMoney(currentPrice());
      box.querySelector('[data-plan-compare]').textContent = formatMoney(priceOnetime * count);
      box.querySelector('[data-plan-compare]').hidden = !subscription && !secondVariantId;
      var savingsPercent = priceOnetime > 0 ? Math.max(0, (1 - currentPrice() / (priceOnetime * count)) * 100) : 0;
      box.querySelector('[data-plan-saving]').textContent = Math.round(savingsPercent) + '% OFF';
      box.querySelector('[data-plan-saving]').hidden = savingsPercent <= 0;
      box.querySelector('[data-plan-serving]').textContent = (count > 1 ? formatMoney(currentPrice() / count) + ' per bag · ' : '') + formatMoney(Math.round(currentPrice() / (25 * count))) + ' per serving';
      box.querySelector('[data-plan-help]').textContent = subscription ? 'Skip, pause, or cancel anytime.' : 'Turn on autoship to save ' + (priceOnetime > 0 ? Math.round(Math.max(0, (1 - priceMonthly / priceOnetime) * 100)) : '0') + '%.';
      box.querySelector('.formthr-subscription-gifts').hidden = !subscription;
      box.querySelector('.formthr-buy-box__subscription-note').hidden = !subscription;
      var summary = box.querySelector('.mthr-flavor-summary');
      summary.hidden = !secondVariantId;
      summary.textContent = secondVariantId ? '1 ' + firstFlavorName + ' + 1 ' + secondFlavorName + ' (second bag 10% off)' : '';
      updateAtcPrice();
    }

    // ── Add to Cart ────────────────────────────────────────────────────
    var atcBtn = box.querySelector('.formthr-buy-box__atc');
    var errEl  = box.querySelector('.formthr-buy-box__atc-error');
    var atcContents = Array.from(atcBtn.childNodes).map(function (node) { return node.cloneNode(true); });

    atcBtn.addEventListener('click', function () {
      if (!selectedVariantId) return;

      var isSubscription = selectedPlan === 'monthly' || selectedPlan === 'quarterly';
      var items = buildItems(isSubscription);

      setLoading(true);

      var body = { items: items };

      // Request section HTML so the cart drawer can refresh after add
      body.sections     = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (d) {
              throw new Error(d.description || 'Could not add to cart.');
            });
          }
          return res.json();
        })
        .then(function (data) {
          setLoading(false);
          if (isSubscription) {
            // Apply the promotion to the cart and render its discounted section HTML.
            // The add response predates the discount and can otherwise show paid gifts.
            return fetch('/cart.js').then(function (response) { return response.json(); }).then(function (cart) {
              var codes = (cart.discount_codes || []).map(function (discount) { return discount.code; });
              if (!codes.some(function (code) { return code.toLowerCase() === 'freegift'; })) codes.push('FreeGift');
              return fetch('/cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(','),sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})});
            }).then(function (response) {
              if (!response.ok) throw new Error('We could not apply the gift offer. Please reopen your cart.');
              return response.json();
            }).then(function (updated) { openCartDrawer(updated); });
          } else {
            openCartDrawer(data);
          }
        })
        .catch(function (err) {
          setLoading(false);
          showError(err.message);
        });
    });

    // ── Helpers ────────────────────────────────────────────────────────

    function buildItems(isSubscription) {
      var items = [];

      [selectedVariantId, secondVariantId].filter(Boolean).forEach(function (variantId) {
        var existing = items.find(function (item) { return item.id === variantId; });
        if (existing) { existing.quantity += 1; return; }
        var item = { id: variantId, quantity: 1 };
        if (isSubscription && monthlyPlanId > 0) item.selling_plan = monthlyPlanId;
        items.push(item);
      });

      // Free gifts added for all subscription orders; FreeGift discount applied at checkout
      if (isSubscription) {
        if (frotherVariantId > 0) items.push({ id: frotherVariantId, quantity: 1, parent_id: selectedVariantId });
        if (toteVariantId    > 0) items.push({ id: toteVariantId,    quantity: 1, parent_id: selectedVariantId });
      }

      if (window.formthrPreorder) items.forEach(function (item) { item.properties = Object.assign({}, item.properties, window.formthrPreorder.properties); });
      return items;
    }

    function setLoading(on) {
      atcBtn.disabled = on;
      if (on) {
        atcBtn.textContent = 'Adding\u2026';
      } else {
        atcBtn.replaceChildren.apply(atcBtn, atcContents.map(function (node) { return node.cloneNode(true); }));
        updateAtcPrice();
      }
      if (errEl && on) errEl.hidden = true;
    }

    function currentPrice() {
      var unitPrice = selectedPlan === 'onetime' ? priceOnetime : priceMonthly;
      return unitPrice + (secondVariantId ? unitPrice - Math.round(unitPrice * 0.10) : 0);
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function updateAtcPrice() {
      var priceEl = atcBtn.querySelector('.formthr-buy-box__atc-price');
      if (priceEl) priceEl.textContent = formatMoney(currentPrice());
      var compareEl = atcBtn.querySelector('.formthr-buy-box__atc-compare');
      if (compareEl) { compareEl.hidden = selectedPlan === 'onetime' && !secondVariantId; compareEl.textContent = formatMoney(priceOnetime * bagCount()); }
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }

    syncPurchase();

    // ── Testimonial — move into media column on desktop ────────────────
    var testimonial = document.querySelector('.formthr-pdp-testimonial');
    var mediaWrapper = document.querySelector('.product__media-wrapper');
    if (testimonial && mediaWrapper) {
      mediaWrapper.appendChild(testimonial);
    }

    function openCartDrawer(data) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      if (data && data.sections) {
        cartDrawer.renderContents(data);
        cartDrawer.classList.remove('is-empty');
      } else {
        cartDrawer.open();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
